import { InvoiceItem } from './types';

export const calculateFreightRev = (gross: string | number, rate: string | number): number => {
  const grossNum = typeof gross === 'string' ? parseFloat(gross || '0') : gross;
  const rateNum = typeof rate === 'string' ? parseFloat(rate || '0') : rate;
  return parseFloat((grossNum * rateNum).toFixed(2));
};

export const calculateFuelSurcharge = (freightRev: number, fuelSurchargePercent: string | number): number => {
  const fuelSurchargeNum = typeof fuelSurchargePercent === 'string' ? parseFloat(fuelSurchargePercent || '0') : fuelSurchargePercent;
  return parseFloat(((freightRev * (fuelSurchargeNum / 10)) / 10).toFixed(2));
};

export const calculateDemurrageCharge = (totalDem: string | number): number => {
  const totalDemNum = typeof totalDem === 'string' ? parseFloat(totalDem || '0') : totalDem;
  return parseFloat((totalDemNum * 100).toFixed(2));
};

export const calculateTotalCharges = (freightRev: number, fuelSurcharge: number, demurrageCharge: number): number => {
  return parseFloat((freightRev + fuelSurcharge + demurrageCharge).toFixed(2));
};

export const calculateAllCharges = (formData: InvoiceItem) => {
  const freightRev = calculateFreightRev(formData.gross, formData.rate);
  const fuelSurcharge = calculateFuelSurcharge(freightRev, formData.fuelSurchargePercent);
  const demurrageCharge = calculateDemurrageCharge(formData.totalDem);
  const totalCharges = calculateTotalCharges(freightRev, fuelSurcharge, demurrageCharge);

  return {
    freightRev,
    fuelSurcharge,
    demurrageCharge,
    totalCharges
  };
};